import Saturation from "./saturation.vue";

export default Saturation;
